import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { type IRpcDispatcher } from '@evercall/json-rpc-dispatcher';
import DITypes from '@evercall/json-rpc-dispatcher/DITypes';
import { TGuestCall } from '@/evercall/domain/vo/call/GuestCall';
import { ICurrency } from '@/evercall/domain/vo/Currency';
import { ILandingPricing } from '@/evercall/domain/vo/Pricing';
import { IPricingCalculatorPayload, IPricingEstimatedCosts } from '@/evercall/domain/vo/PricingCalculator';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';

@injectable()
class EvercallRepository {
  constructor(
    @inject(DITypes.WebServiceRpcDispatcher) private webServiceRpc: IRpcDispatcher,
  ) {}

  getPricing = async (payload: { currencyId: string }): Promise<{ currency: ICurrency, pricing: ILandingPricing }> => {
    const req = new Request(
      'evercall.guest.pricing.view',
      payload,
    );
    const response = await this.webServiceRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  /**
   * Schedule Oacc Call from Evercall landing page
   */
  scheduleOaccCallAsGuest = async (payload: TGuestCall): Promise<null> => {
    const req = new Request(
      'evercall.guest.oacc_call.schedule',
      payload,
    );
    const response = await this.webServiceRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  /**
   * Schedule Webinar Call from Evercall landing page
   */
  scheduleWebinarCallAsGuest = async (payload: TGuestCall): Promise<null> => {
    const req = new Request(
      'evercall.guest.webinar_call.schedule',
      payload,
    );
    const response = await this.webServiceRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  /**
   * Estimate pricing fee
   */
  calculatePricingFee = async (payload: IPricingCalculatorPayload): Promise<IPricingEstimatedCosts> => {
    const req = new Request(
      'evercall.guest.call_estimated_fee.calculate',
      payload,
    );

    const response = await this.webServiceRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  getCurrencies = async (): Promise<Array<ICurrency>> => {
    const req = new Request(
      'evercall.currencies.view',
      {},
    );
    const response = await this.webServiceRpc.call<RpcSuccess>(req);

    return response.getResult().payload.collection;
  };
}

export default EvercallRepository;
